import { FunctionComponent, PropsWithChildren } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const ReviewLayout: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <>
        <Box mb={2}>
            <Typography variant="h1" color="primary.light" gutterBottom>
                Ecopilot Output
            </Typography>
            <Typography variant="h3" fontWeight="400" sx={{ display: 'flex', alignItems: 'center' }}>
                Review and edit Ecopilot’s EF suggestions
                <Tooltip title="You can select one or more materials from your list and either mark them as correct, mark them as uncertain or edit them. Editing opens the ecopilot single search and allows you to search for a better alternative. To make your review easier you can also group the list by any column, just hover over the column name and click on the three dot menu.">
                    <HelpOutlineIcon sx={{ color: 'primary.light', marginLeft: 1 }} />
                </Tooltip>
            </Typography>
        </Box>

        {children}
    </>
);

export default ReviewLayout;
